<template>
    
    <div :id="_uid" class="ui calendar">
      <div class="ui input left icon" :class="{ disabled, small }" :style="inputStyle">
        <i class="calendar icon"></i>
        <input :id="_uid + '_input'" class="date" :readonly="readonly">
      </div>
    </div>

</template>

<script>

  import { Calendar, moment } from "@/utils"
  
  export default {

    data() {
      return {
        initiated: false,
      }
    },

    props: {
      disabled: { type: Boolean, default: false },
      readonly: { type: Boolean, default: false },
      autoInit: { type: Boolean, default: true },
      small: { type: Boolean, default: false },
      inputStyle: { type: String, default: "" },
      position: { type: String, default: "" },
    },
    
    mounted() {

      if (this.autoInit)
        this.initCalendar()
    },

    methods: {

      initCalendar(options) {

        const force = (options && options.force)

        if (this.initiated && !force)
          return  
        
        this.initiated = true

        let data = {
          onShow: () => this.readonly ? false : true,
          onChange: (date) => this.$emit("onChange", date ? moment(date).format("YYYY-MM-DD") : null),
        }

        if (this.position)
          data.popupOptions = { position: this.position }

        Calendar.init(`#${this._uid}`, data)

        $(`#${this._uid}_input`).prop("readonly", this.readonly)
      },

      setDate(date) {
        $("#" + this._uid).calendar("set date", moment(date).toDate())
      },

      clearDate() {
        $("#" + this._uid).calendar("set date", null)
      },
    },
  }
</script>

